import { createLocalZustand } from '@/shared/state';
import { parseSearchGroups } from '@/shared/utils/partnerships-history-parse';
import { OpenAPIHousien } from '@services/requests';
import { request as __request } from '@services/requests/core/request';
import type { PartnershipsHistoryState } from './partnerships-history-types';
import { INITIAL_HISTORY_FILTERS } from './partnerships-history-types';

export const {
  Context: PartnershipsHistoryContext,
  Provider: PartnershipsHistoryProvider,
  Consumer: PartnershipsHistoryConsumer,
  useStore: usePartnershipsHistory,
} = createLocalZustand<PartnershipsHistoryState>(() => (set) => ({
  groups: [],
  loading: true,
  error: null,
  filters: { ...INITIAL_HISTORY_FILTERS },

  setFilters: (patch) =>
    set((s) => ({ filters: { ...s.filters, ...patch } })),

  loadSearches: async (agencyId: string) => {
    set(() => ({ loading: true, error: null }));
    try {
      const resp = await __request(OpenAPIHousien, {
        method: 'GET',
        url: '/agencies/{agencyId}/partnerships/searches',
        path: { agencyId },
      });
      set(() => ({ groups: parseSearchGroups(resp), loading: false }));
    } catch {
      set(() => ({ loading: false, error: 'Failed to load searches.' }));
    }
  },
}));
